const MyCcComponent = () => import('@/views/user/MyCcView')

export default [
    {
        path:'/MyCc',
        name:'MyCcComponent',
        component:MyCcComponent
    }
]